module.exports = __webpack_public_path__ + "img/icon_recruit_welfare_02.39057c51.png";